import { create } from 'zustand';

export const useAuthenticationStore = create((set) => ({
  unauthorizedError: false,
  setUnauthorizedError: (value) => set({ unauthorizedError: value })
}));
